import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import AlertService from '../../../common/AlertService'
import AlertSettingService from '../../core/AlertSettingService'

export const getPortfolios = createAsyncThunk(
  'alerts/getPortfolios',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.getPortfolios(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getProfileDefault
export const getProfileDefault = createAsyncThunk(
  'alerts/getProfileDefaultDynamic',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertSettingService.getProfileDefault(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
